import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import manage from '@/constants/manage';
export default {
  name: 'ruleItem',
  props: {
    item: {
      type: Object
    },
    jobList: {
      type: Array
    },
    num: {
      type: Number
    }
  },
  data: function data() {
    return {
      attrList: [{
        key: 'INCLUDE',
        value: '属于'
      }, {
        key: 'EXCLUDE',
        value: '不属于'
      }],
      dictList: JSON.parse(sessionStorage.getItem('dist_info')),
      dictInfo: '',
      buslinList: [],
      JOB_CODE: {
        item_list: ''
      },
      jobRule: {
        itemIdList: [{
          required: true,
          message: '职位为必填选项',
          trigger: 'change'
        }]
      },
      topId: manage.HEAD_ORG_ID
    };
  },
  created: function created() {
    this.dictInfo = this.dictList.BUSINESS_LINE || null;
    if (this.dictInfo !== null) {
      // eslint-disable-next-line guard-for-in
      for (var i in this.dictInfo) {
        this.buslinList.push({
          key: i,
          value: this.dictInfo[i]
        });
      }
    }
  },
  methods: {
    jobChange: function jobChange() {
      this.JOB_CODE.item_list = this.$refs.item_list.value;
    },
    delRule: function delRule() {
      this.$emit('delRuleItem', this.num);
    }
  }
};